import React from 'react';
import _ from 'lodash';

import {
  useReplaceItemModalQuery,
  useTriageTier1ReturnAuthorizationMutation
} from 'generated/graphql';

import * as types from './types';



export interface IData {
  triageWorkflowId: string;
  formState: types.IFormState;
}

export function useQuery(returnAuthorizationId: string) {
  const tuple = useReplaceItemModalQuery({
    variables: {
      returnAuthorizationId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        triageWorkflowId: _.find(tuple.data?.tier1ReturnAuthorization?.group.store.triageWorkflows, wf => wf.type.name === 'replacement')?.id ?? '',
        formState: {
          repairCode: null,
          replacementSerialNumber: tuple.data?.tier1ReturnAuthorization?.itemReceipt?.serialNumber ?? '',
          technicianComment: ''
        }
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useTriageTier1ReturnAuthorization(returnAuthorizationId: string, triageWorkflowId: string) {
  const [fnMutate, tuple] = useTriageTier1ReturnAuthorizationMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (formState: types.IFormState) => {
      await fnMutate({
        variables: {
          input: {
            returnAuthorizationId,
            triageWorkflowId,
            replacementSerialNumber: formState.replacementSerialNumber,
            repairCodeId: formState.repairCode?.id ?? '',
            technicianComment: formState.technicianComment
          }
        }
      });
    },
    [
      fnMutate,
      returnAuthorizationId,
      triageWorkflowId
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
